import { render, staticRenderFns } from "./Secondary.vue?vue&type=template&id=06a890fa&scoped=true"
import script from "./Secondary.vue?vue&type=script&lang=js"
export * from "./Secondary.vue?vue&type=script&lang=js"
import style0 from "./Secondary.vue?vue&type=style&index=0&id=06a890fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a890fa",
  null
  
)

export default component.exports